<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('ticketstatus_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-ticket</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-ticketstatus-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                <v-chip
              class="ma-1 font-weight-bold"
              label
              :color="statuscolor(item)"
            >
              <v-icon left v-if="item.init">
                mdi-new-box
              </v-icon>
              <v-icon left v-if="item.finish">
                mdi-flag-checkered
              </v-icon>
              <v-icon left v-if="! item.finish && ! item.init">
                mdi-cached
              </v-icon>
              <span >{{ item.name }}</span>
            </v-chip>
    
              </td>
              <td><strong>{{ $t('global.namefr') }}</strong></td>
              <td>
                                    {{ item['namefr'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.finish') }}</strong></td>
              <td>
                                    {{ item['finish'] }}
              </td>
              <td><strong>{{ $t('ticket.important') }}</strong></td>
              <td>
                                    {{ item['important'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.init') }}</strong></td>
              <td>
                                    {{ item['init'] }}
              </td>
              <td><strong>{{ $t('ticket.waiting') }}</strong></td>
              <td>
                                    {{ item['waiting'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.process') }}</strong></td>
              <td>
                                    {{ item['process'] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'Ticketstatus';

export default {
  name: 'TicketstatusShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('ticketstatus', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('ticketstatus', ['find'])
  },
  methods: {
    ...mapActions('ticketstatus', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    statuscolor(status) {
      if (status.important) {
        return 'error';
      }
      if (status.init) {
        return 'primary';
      }
      if (status.finish) {
        return 'success';
      }
      return 'accent';
    }
  }
};
</script>
